import { render, staticRenderFns } from "./ClassItem.vue?vue&type=template&id=5119afe0&scoped=true&"
import script from "./ClassItem.vue?vue&type=script&lang=js&"
export * from "./ClassItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassItem.vue?vue&type=style&index=0&id=5119afe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5119afe0",
  null
  
)

export default component.exports